<div class="authenticating-container" *ngIf="isNavigating">
  <div class="authenticating-card">
    <div class="scout-loader-wrapper">
      <!-- Animated Pulsing/Spinning Premium Ring -->
      <div class="scout-loader-ring"></div>
      <div class="scout-loader-ring-inner"></div>
      
      <!-- Premium compass/scout golden SVG icon -->
      <div class="scout-loader-icon-container">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" class="scout-icon">
          <circle cx="12" cy="12" r="10" stroke="#c5a669" stroke-opacity="0.2"/>
          <polygon points="16.24,7.76 14.12,14.12 7.76,16.24 9.88,9.88" fill="url(#goldGradient)"/>
          <defs>
            <linearGradient id="goldGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stop-color="#9a7b2e" />
              <stop offset="50%" stop-color="#e8d5a3" />
              <stop offset="100%" stop-color="#c5a669" />
            </linearGradient>
          </defs>
        </svg>
      </div>
    </div>
    
    <h2 class="authenticating-title">Hang on!</h2>
    <p class="authenticating-text">We are redirecting you to Scout...</p>
    
    <!-- Micro dot loader -->
    <div class="dots-container">
      <div class="dot"></div>
      <div class="dot"></div>
      <div class="dot"></div>
    </div>
  </div>
</div>

<div class="login-container" *ngIf="!isNavigating">
  <section class="hero">
    <div class="hero-bg">
      <img src="https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&q=80"
        alt="Modern Office" class="bg-img">
      <div class="overlay"></div>
    </div>

    <div
      class="login-form-container flex flex-col md:flex-row items-center justify-between w-full max-w-7xl mx-auto px-6 gap-12">

      <div
        class="login-card w-full max-w-[420px] bg-white/95 backdrop-blur-sm p-10 rounded-2xl shadow-2xl border border-white/20 transition-all duration-300">
        <div class="login-form-wrapper w-full">

          <div class="logo mb-10 flex justify-center">
            <img src="logo-black.png" alt="Retail Calculus" class="max-w-[180px] h-auto object-contain">


          </div>
          <div class="flex justify-center mt-2 mb-8">
            <h2 class="login-scout-title" aria-label="Scout">Scout</h2>
          </div>
          <!-- <div class="login-text text-center mb-6 text-gray-600 font-medium">Login to Scout</div> -->

          <form class="space-y-6" #loginForm="ngForm" (ngSubmit)="login()">

            <div class="space-y-2">
              <label for="username" class="block text-sm font-semibold text-gray-700">Username</label>
              <div class="relative group">
                <div
                  class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-400 group-focus-within:text-blue-500 transition-colors">
                  <i class="fa-solid fa-user text-sm"></i>
                </div>
                <input type="text" id="username" [(ngModel)]="user.username" (ngModelChange)="login_error = false" name="username" autofocus required
                  placeholder="Enter your username"
                  class="block w-full pl-10 pr-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-gray-900 focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 outline-none transition-all duration-200 placeholder:text-gray-400">
              </div>
            </div>

            <div class="space-y-2">
              <label for="password" class="block text-sm font-semibold text-gray-700">Password</label>
              <div class="relative group">
                <div
                  class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-400 group-focus-within:text-blue-500 transition-colors">
                  <i class="fa-solid fa-lock text-sm"></i>
                </div>
                <input type="password" id="password" [(ngModel)]="user.password" (ngModelChange)="login_error = false" name="password" required
                  placeholder="Enter your password"
                  class="block w-full pl-10 pr-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-gray-900 focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 outline-none transition-all duration-200 placeholder:text-gray-400">
              </div>
            </div>

            <div class="flex items-center justify-between text-sm py-1" *ngIf="login_error">
              <div class="flex items-center gap-2 text-red-600 bg-red-50 px-3 py-2 rounded-lg w-full">
                <i class="fa-solid fa-circle-exclamation shadow-sm"></i>
                <span class="font-medium">{{ login_message }}</span>
              </div>
            </div>

            <button type="submit" id="loginButton"
              class="w-full py-3.5 bg-gray-900 hover:bg-black text-white font-bold rounded-xl shadow-lg hover:shadow-xl transform transition-all duration-200 active:scale-[0.98] disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-3"
              [disabled]="loginForm.invalid || isProcessing">

              <ng-container *ngIf="!isProcessing">
                <span>{{ loginButtonText }}</span>
                <i class="fa-solid fa-arrow-right-to-bracket text-sm opacity-100 text-white"></i>
              </ng-container>

              <span *ngIf="isProcessing"
                class="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin"></span>
            </button>

          </form>
        </div>
      </div>

      <div class="hero-visual">
        <div class="floating-card card-1">
          <div class="card-icon icon-blue"><i class="fa-solid fa-user-shield"></i></div>
          <div class="card-text">
            <small>Roles & Permissions</small>
            <span>Control user access and staff permissions</span>
          </div>
        </div>
        <div class="floating-card card-2">
          <div class="card-icon icon-gold"><i class="fa-solid fa-users-gear"></i></div>
          <div class="card-text">
            <small>User Management</small>
            <span>Manage users and organization profiles</span>
          </div>
        </div>
        <div class="floating-card card-3">
          <div class="card-icon icon-green"><i class="fa-solid fa-tower-broadcast"></i></div>
          <div class="card-text">
            <small>Session Monitoring</small>
            <span>Track live sessions and platform activity</span>
          </div>
        </div>
      </div>
    </div>
  </section>

  <footer class="login-footer">
    <span *ngIf="copyrightDetails">
      &copy; {{ copyrightDetails.from_year }} - {{ copyrightDetails.to_year }},
      Retail Calculus or its affiliates. All rights reserved.
    </span>
    <span *ngIf="!copyrightDetails">
      &copy; 2016 - 2026, Retail Calculus or its affiliates. All rights reserved.
    </span>

    <div class="footer-links">
      <a href="javascript:void(0)">Privacy Policy</a>
      <a href="javascript:void(0)">Terms of Use</a>
      <span class="version" *ngIf="copyrightDetails?.app_version">
        Version {{ copyrightDetails.app_version }}
      </span>
    </div>
  </footer>

</div>